import React from 'react';

import { Text } from '@sitecore-jss/sitecore-jss-react';

import { WarningCircle, InfoCircle, Warning } from '_utils/icons';

import {
  AnnouncementWrapper,
  TitleWrapper,
  Content,
  TextWrapper,
  IconWrapper
} from './StyledInPageAnnouncement';

type AnnouncementProps = {
  description: any;
  id: any;
  link: any;
  title: any;
  type: any;
};

const Icons = {
  Primary: <InfoCircle />,
  Warning: <WarningCircle />,
  'High alert': <Warning />
};

const Announcement: React.FC<AnnouncementProps> = ({ description, link, title, type }) => {
  let titleWrapperAttrs = {
    as: 'div',
    href: null,
    target: null,
    tabIndex: null
  };

  if (link.value.href !== '') {
    titleWrapperAttrs.as = 'a';
    titleWrapperAttrs.href = link.value.href;
    titleWrapperAttrs.target = link.value.target;
  }

  return (
    <AnnouncementWrapper role="alert" $alertStyle={type.value || 'Primary'}>
      <IconWrapper>{Icons[type.value || 'Primary']}</IconWrapper>
      <TextWrapper>
        <TitleWrapper {...titleWrapperAttrs}>
          <h2>
            <Text field={title} editable={false} />
          </h2>
        </TitleWrapper>

        {description.value !== '' && <Content field={description} editable={false} />}
      </TextWrapper>
    </AnnouncementWrapper>
  );
};

export default Announcement;
